// extracted by mini-css-extract-plugin
export default {"GraphWrapper":"GraphWrapper_GraphWrapper__nmJzG","GraphWrapperInner":"GraphWrapper_GraphWrapperInner__8xOvO"};